import { BaseClient } from '../client';

interface postSupportProps {
	idUsuario: string;
	nomeUsuario: string;
	tipoEmail: string;
	mensagem: string;
}

export const postSupport = async (body: postSupportProps) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 'Enviado com sucesso!';
	// }

	try {
		const response = await BaseClient.post<string>(`/Sistema`, body).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
